import classNames from "classnames";
import React from "react";

import { VenueContext } from "../../VenueContext";
import Framed from "../Framed";
import Header from "../Header";
import Hero from "../Hero";
import Panel from "../Panel";
import TiledBackground from "../TiledBackground";
import { Link } from "../TrackedLink";

import bexleyImage from "./images/bexley.webp";
import elthamImage from "./images/eltham.webp";
import heroNarrow from "./images/pub-narrow.webp";
import hero from "./images/pub.webp";
import * as styles from "./styles.module.scss";

const Home = () => (
  <>
    <Header sections={[]} />
    <Hero src={hero} narrowSrc={heroNarrow} />
    <VenueContext.Provider value="Bexley">
      <div className={styles.venueWrapper}>
        <TiledBackground>
          <div className={classNames(styles.venue, styles.bexley)}>
            <Link to="/bexley">
              <div className={styles.imageContainer}>
                <Framed>
                  <img src={bexleyImage} className={styles.venueImage} />
                </Framed>
              </div>
              <div className={styles.button}>
                <Panel text="Bexley" />
              </div>
            </Link>
          </div>
        </TiledBackground>
      </div>
    </VenueContext.Provider>
    <VenueContext.Provider value="Eltham">
      <div className={styles.venueWrapper}>
        <TiledBackground>
          <div className={styles.venue}>
            <Link to="/eltham">
              <div className={styles.imageContainer}>
                <Framed>
                  <img src={elthamImage} className={styles.venueImage} />
                </Framed>
              </div>
              <div className={styles.button}>
                <Panel text="Eltham" />
              </div>
            </Link>
          </div>
        </TiledBackground>
      </div>
    </VenueContext.Provider>
  </>
);

export default Home;
